import { Form } from "react-router-dom";
import Box from "../components/Box/Box";
import BackButton from "../components/Buttons/BackButton";
import useFocusOnLoad from "../hooks/useFocusOnLoad";

export default function Fail() {
    const h2Ref = useFocusOnLoad<HTMLHeadingElement>();

    return (
        <div>
            <Form>
                <Box>
                    <h2 ref={h2Ref} tabIndex={-1} id="sendFailedHeading">Något gick fel</h2>
                    <p>Något verkar ha gått fel i din anmälan. Testa gärna igen.</p>
                    <p>Har du frågor kan du kontakta kundservice på <a href="tel:0771-21 10 10">0771-21 10 10</a></p>
                </Box>
                <div className="flex justify-center">
                    <div className="w-full text-left flex items-center">
                        <BackButton />
                    </div>
                </div>
            </Form>
        </div>
    );
}
